import React from 'react';
import ZVersions from '../../z-versions';
import ZPublish from '../../z-publish';

const VersionsView = ({
  actions, id, modalState, paths, published, onCloseModal,
  onClickUnpublish, saved, showModal, usageReferences,
}) => (
  <>
  <ZVersions
    actions={actions}
    entityId={id}
    entityType="guides"
    onClickUnpublish={onClickUnpublish}
    published={published}
    saved={saved}
  />
  {showModal && (
    <ZPublish
      entityId={id}
      entityType="Guide"
      modalState={modalState}
      onCloseModal={onCloseModal}
      paths={paths}
      showModal={showModal}
      usageReferences={usageReferences}
      usageReferencesError={(
        <>
          <h2>This guide is being used.</h2>
          <p>
            Please go to the Usage References tab.
            <br/>
            Visit the pages listed and remove it from the navigation bar.
          </p>
        </>
      )}
    />
  )}
  </>
);

export default VersionsView;
